<template>
  <div
    :class="[
      isHRPlatform ? 'title-header-standard' : 'title-header'
    ]"
  >
    <div class="title-header-text" id="knowledge-categories">
      <div class="row">
        <div class="col-auto">
          <div class="dropdown w-auto d-inline-block" v-if="showDropdownForKnowledgeBrowse">
            <a class="nav-link dropdown-btn pr-0" data-toggle="dropdown" aria-expanded="false" href="#">
              <span v-if="currentServiceArea" class="mr-1 nav-lnk-container">
                <span class="d-md-inline">{{ displayPlatformCategory }} Articles: </span>
                <span>{{ currentTitleCategory }}</span>
              </span>
              <span class="category-drop-down-arrow down"> </span>
            </a>
            <div
                    class="dropdown-menu container-fluid category-container"
                    aria-labelledby="dropdownMenuButton"
            >
              <div v-for="servicearea in serviceAreas" :key="servicearea.id">
                <router-link
                        v-if="validateArticlesLength(servicearea)"
                        @click="clickBKRoute(servicearea)"
                        class="dropdown-item servicearea-dropdown-item"
                        :class="{
                    'router-link-exact-active': servicearea.id === currentServiceArea.id
                  }"
                        :to="{ name: servicearea.id ?  'knowledge-articles-by-id' : 'knowledge-articles',
                    params: {platformCategory, id: servicearea.id}
                  }"
                >{{ servicearea.name }} ({{ servicearea.articles.length }})</router-link>
              </div>
            </div>
          </div>
          <div v-else class="w-auto d-inline-block nav-lnk-container">
            <span class="d-md-inline"><span class="nav-link-no-dropdown">{{ displayPlatformCategory }} Articles: {{singleServiceLine.name}}({{ singleServiceLine.articleCount }})</span></span>
          </div>
          <employee-hub-bookmark :title="bookmarkTitle" :key="$route.params.id" :env="env" show-circle class="eh-bookmark"></employee-hub-bookmark>
        </div>
      </div>

      <div class="row h-auto">
        <div class="col-xl-5 col-lg-6 col-12">
          <div v-if="validateArticlesLength(currentServiceArea)" class="search-container mt-2">
            <div class="input-group-prepend search-icon-container">
              <span class="input-group-text">
                <img src="@/assets/image/icon_search.svg" />
              </span>
              <div class="input-container">
                <input
                  v-model="inputSearchText"
                  type="text"
                  placeholder="Search all articles in the selected category"
                  class="form-control"
                />
              </div>
              <button
                v-if="inputSearchText && inputSearchText.length > 0"
                @click="cleanSuggestedArticles"
                class="close close-btn mr-1"
              >
                <font-awesome-icon :icon="['far', 'times-circle']" size="lg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
import _lodash from "lodash";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { renamePlatformCategory } from "@/utils/componentImportUtils";

library.add(faTimesCircle);

export default {
  components: {
    FontAwesomeIcon
  },
  name: "KnowledgeCategories",
  data() {
    return {
      hrPlatform: CONSTANTS.HR_PLATFORM,
      inputSearchText: "",
      env: CURRENT_ENV
    };
  },
  computed: {
    //only applicable when showDropdownForKnowledgeBrowse: false
    //its set to false in BrowseKnowledge.vue when categories length is exactly 1.
    singleServiceLine() {
      let singleServiceLineObj = this.serviceAreas.find(serviceArea => serviceArea.name === CONSTANTS.CAPITALIZE_ALL_TEXT)
      return { name: singleServiceLineObj.name, articleCount: singleServiceLineObj.articles.length }
    },
    isHRPlatform() {
      return this.platformCategory == this.hrPlatform
    },
    displayPlatformCategory() {
        let categoryTitle = renamePlatformCategory(this.platformCategory);
        if (this.platformCategories && this.platformCategories.length > 0) {
            this.platformCategories.forEach(category => {
                if(category.alias == this.platformCategory){
                categoryTitle = category.name;
            }
        });
        }
        return categoryTitle;
    },
    bookmarkTitle() {
      return this.displayPlatformCategory+ " Articles: " + this.currentTitleCategory
    },
    ...mapGetters(["platformCategory","platformCategories"]),
    validateArticlesLength: function() {
      return serviceArea => serviceArea.articles && serviceArea.articles.length;
    },
    currentTitleCategory() {
      if(this.showDropdownForKnowledgeBrowse) {
        const titleCategory = `${this.currentServiceArea.name} (${this
            .currentServiceArea &&
        this.currentServiceArea.articles &&
        this.currentServiceArea.articles.length})`;
        return titleCategory;
      } else {
        return `${this.singleServiceLine.name} (${this.singleServiceLine.articleCount})`
      }

    }
  },
  props: {
    serviceAreas: Array,
    currentServiceArea: Object,
    showDropdownForKnowledgeBrowse: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapMutations([
      "setCurrentCategory",
      "setInputFilter",
      "setFilteredArticles",
      "setArticlesLoading"
    ]),
  ...mapActions(["fetchPlatformCategories"]),
    clickBKRoute(sa) {
      this.$hhMixpanel.trackEvent(
        `${this.platformCategory} Knowledge Browse - ${sa.name}`
      );
      this.cleanSuggestedArticles();
      this.$emit("clickBKRoute", sa);
      this.setCurrentCategory(sa);
    },
    cleanSuggestedArticles() {
      this.inputSearchText = "";
      this.setInputFilter("");
    },
    debounceSearch: _lodash.debounce(that => {
      that.setInputFilter(that.inputSearchText);
    }, 500)
  },
  created() {
    this.fetchPlatformCategories()
},
  watch: {
    inputSearchText() {
      this.debounceSearch(this);
    },
  }
};
</script>

<style scoped>
.title-header {
  height: auto;
  padding-top: 32px;
}
.title-header-text {
  color: #000000;
  font-size: 18px;
}

.title-header-text .nav-link-no-dropdown {
  font-size: 38px !important;
  padding-left: 0 !important;
}

.nav-lnk-container {
  font-family: artifaktElementBold;
}

.dropdown-btn {
  padding-left: 0;
  text-transform: none;
  color: #fff;
  font-size: 38px !important;
  font-weight: bold;
  border: 0;
  outline: 0;
}
.servicearea-dropdown-item {
  padding: 15px 15px 15px 30px;
}

.servicearea-dropdown-item a{
  color: #000 !important;
}

.category-container .router-link-exact-active {
  color: var(--secondary-color) !important;
  font-weight: bold;
}

.category-container {
  z-index: 1;
  max-height: 440px;
  overflow-y: auto;
}
.dropdown-item {
  color: #212529 !important;
  font-size: 20px;
}
.dropdown-item:hover {
    background: var(--background-color-hover) !important;
    text-decoration: none !important;
}
.search-container {
  background: #ffffff;
}
.category-drop-down-arrow {
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
  background: transparent;
  text-indent: -9999px;
  border-top: 6px solid #000000;
  border-left: 6px solid #000000;
  text-decoration: none;
  color: transparent;
}

.category-drop-down-arrow.down {
  transform: rotate(-135deg);
  margin: 6px;
}

.nav-link[aria-expanded="true"] .category-drop-down-arrow {
  border-top: 6px solid #000000;
  border-left: 6px solid #000000;
}

.input-container {
  width: 100%;
}

.input-container input {
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-header-standard {
	background: transparent;
	padding-top:30px;
}

.search-icon-container span {
  border: 1px solid #000000;
  border-right: none;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #b9b9b9;
  padding-right: 7px;
  cursor: pointer;
  background: #ffffff;
}

.search-icon-container input {
  color: #000000;
  border-radius: 25px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 1px solid #000000;
  border-left: none;
  font-size: 16px;
  padding-left: 8px;
  background: #ffffff;
}

.search-icon-container input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000000;
}

.input-group-text {
  background: #1758A7;
}


.search-icon-container input:focus {
  color: #000;
  background-color: #fff;
  background: #fff;
  outline: 0;
  /* border-color: #ced4da !important; */
  box-shadow: none !important;
}

.input-group-prepend {
  height: 40px;
  position: relative;
}

.dropdown-item:active {
  background-color: var(--background-color-hover) !important;
  font-weight: bold;
}

.form-control:focus {
  border-color: #495057 !important;
}
.articles-suggestion-container {
  position: relative;
  width: 100%;
}

.suggest-results {
  position: absolute;
  background: #fff;
  color: #666;
  width: 100%;
  z-index: 999;
  border: 1px solid #cecece;
  box-shadow: 0 10px 21px 0 #b4b4b4;
  overflow-y: auto;
}
.suggest-results-list {
  list-style: none;
  overflow-y: auto;
  max-height: 60vh;
}

.article-container {
  cursor: pointer;
}

.article-container:hover,
.article-container:hover span {
  background-color: #ddd;
}

.article-container span {
  color: #000;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: -2px;
  height: 100%;
  outline: none;
  color: #2f3642;
}

.close-btn svg {
  width: 0.65em;
  height: 0.8em;
  color: #fff;
}

.close {
  opacity: initial;
}
.dropdown-menu {
  width: auto;
}
#knowledge-categories :deep(a:hover){
  color: #000000 !important;
}
@media only screen and (min-width: 200px) and (max-width: 767px) {
  .dropdown-menu {
    width: 100%;
  }
  .servicearea-dropdown-item {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

</style>
